import { UnknownAction } from "@reduxjs/toolkit";
import {
  FETCH_EXPERIENCES_WORKSPACES_REQUEST,
  FETCHING_EXPERIENCES_WORKSPACES_SUCCEEDED,
  FETCHING_EXPERIENCES_WORKSPACES_FAILED,
  FETCH_EXPERIENCES_WORKSPACE_REQUEST,
  FETCHING_EXPERIENCES_WORKSPACE_SUCCEEDED,
  FETCHING_EXPERIENCES_WORKSPACE_FAILED,
} from "../../actions/actionTypes";
import { WorkspaceItem } from "src/types/experiences/workspaces";

interface WorkspacesReducerState {
  loading: boolean;
  fetched: boolean;
  items: WorkspaceItem[];
  workspace: {
    loading: boolean;
    item: WorkspaceItem | null;
  };
  error: any;
}

const initialState: WorkspacesReducerState = {
  loading: false,
  fetched: false,
  items: [],
  workspace: {
    loading: false,
    item: null,
  },
  error: null,
};

export const workspacesReducer = (
  state: WorkspacesReducerState = initialState,
  action: UnknownAction
): WorkspacesReducerState => {
  switch (action.type) {
    // ─── List ───────────────────────────────────────────────────────────────
    case FETCH_EXPERIENCES_WORKSPACES_REQUEST:
      return { ...state, loading: true, fetched: false, error: null };

    case FETCHING_EXPERIENCES_WORKSPACES_SUCCEEDED:
      return {
        ...state,
        loading: false,
        fetched: true,
        items: action.payload as WorkspaceItem[],
        error: null,
      };

    case FETCHING_EXPERIENCES_WORKSPACES_FAILED:
      return { ...state, loading: false, fetched: false, error: action.payload };

    // ─── Single (on select) ─────────────────────────────────────────────────
    case FETCH_EXPERIENCES_WORKSPACE_REQUEST:
      return {
        ...state,
        workspace: { ...state.workspace, loading: true },
        error: null,
      };

    case FETCHING_EXPERIENCES_WORKSPACE_SUCCEEDED:
      return {
        ...state,
        workspace: { loading: false, item: action.payload as WorkspaceItem },
        error: null,
      };

    case FETCHING_EXPERIENCES_WORKSPACE_FAILED:
      return {
        ...state,
        workspace: { ...state.workspace, loading: false },
        error: action.payload,
      };

    default:
      return state;
  }
};
